import { PhoneNumberE164, TaskTypeId } from "@sp-crm/core";
import { InputFormBlock } from "components/app/input-form-block";
import { Header } from "components/header";
import { VisitParent } from "components/visits/types";
import React from "react";
import { OrgCallOptions, TouchpointRow, TouchpointRowView } from "./touchpoint-row";

interface EntityMarketingPlanProps {
    variant: "marketingPlan" | "recommendedActions";
    emptyStateNoun: string;
    touchpoints: TouchpointRowView[] | null;
    parent: VisitParent | null;
    email: string | null;
    emailOptedOut: boolean;
    phone: PhoneNumberE164 | null;
    hasPhoneLine: boolean;
    orgCallOptions?: OrgCallOptions;
    onSendEmail: (activityTypeId: TaskTypeId | null) => void;
}

export const EntityMarketingPlan: React.FC<EntityMarketingPlanProps> = ({
    variant,
    emptyStateNoun,
    touchpoints,
    parent,
    email,
    emailOptedOut,
    phone,
    hasPhoneLine,
    orgCallOptions,
    onSendEmail,
}) => (
    <InputFormBlock>
        {variant === "recommendedActions" ? (
            <Header>Recommended Actions</Header>
        ) : (
            <Header iconName="25_ActiveTasks">Marketing Playbook</Header>
        )}
        {touchpoints && parent ? (
            <div className="divide-y divide-gray-100">
                {touchpoints.map(touchpoint => (
                    <TouchpointRow
                        key={touchpoint.touchpointId}
                        touchpoint={touchpoint}
                        parent={parent}
                        email={email}
                        emailOptedOut={emailOptedOut}
                        phone={phone}
                        hasPhoneLine={hasPhoneLine}
                        orgCallOptions={orgCallOptions}
                        onSendEmail={onSendEmail}
                    />
                ))}
            </div>
        ) : (
            <p className="text-sm text-gray-500">
                Set a referral tier to get recommended outreach actions for this{" "}
                {emptyStateNoun}.
            </p>
        )}
    </InputFormBlock>
);
